/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Validation_Emailinvalid1Inputs */

const he_contact_validation_emailinvalid1 = /** @type {(inputs: Contact_Validation_Emailinvalid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כתובת דוא"ל לא תקינה`)
};

const en_contact_validation_emailinvalid1 = /** @type {(inputs: Contact_Validation_Emailinvalid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid email address`)
};

/**
* | output |
* | --- |
* | "Invalid email address" |
*
* @param {Contact_Validation_Emailinvalid1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_validation_emailinvalid1 = /** @type {((inputs?: Contact_Validation_Emailinvalid1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Validation_Emailinvalid1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_validation_emailinvalid1(inputs)
	return en_contact_validation_emailinvalid1(inputs)
});
export { contact_validation_emailinvalid1 as "contact_validation_emailInvalid" }